/* The bar-chart icon shared by the Agents Analytics and MCP Analytics nav items
   (agent-studio.html:3459 and :3464 use identical paths).

   `strokeWidth` defaults to the nav weight (1.8) but is overridable because the
   prototype draws this icon at stroke-width 2 when it appears as a product
   avatar on the MCP Analytics overview and page header (:5763, :5872) rather
   than in the nav. Same icon, two weights — MS-700 AC-4 requires it to be this
   icon in all three places. */
export function AnalyticsIcon({
  size = 18,
  strokeWidth = 1.8,
}: { size?: number; strokeWidth?: number } = {}) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} stroke="currentColor" fill="none" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <line x1="18" y1="20" x2="18" y2="10"/>
      <line x1="12" y1="20" x2="12" y2="4"/>
      <line x1="6" y1="20" x2="6" y2="14"/>
    </svg>
  )
}
